import { UIKitIcon } from '../icon';

export const layersIcon: UIKitIcon = {
  name: 'layers',
  // tslint:disable-next-line: max-line-length
  data: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><polyline points="21 18.5 26 21 16 26 6 21 11 18.5" fill="none" '
  + 'stroke="inherit" stroke-miterlimit="10"/><polyline points="21 18.5 26 21 16 26 6 21 11 18.5" fill="none" stroke="inherit" '
  + 'stroke-miterlimit="10"/><polyline points="21 13.5 26 16 16 21 6 16 11 13.5" fill="none" stroke="inherit" stroke-miterlimit="10"/>'
  + '<polygon points="26 11 16 16 6 11 16 6 26 11" fill="none" stroke="inherit" stroke-miterlimit="10"/></svg>',
};
